module.exports = __webpack_public_path__ + "img/bybit_3.aa339542.png";